/** Coupon/rewards component */

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { RewardInline } from '../../common/components/displayItems/rewards.jsx';
import { Header } from '../../common/components/displayItems/document.jsx';
import { isAssetRef, assetFromRef } from '../utils/utils';
import { queryStringObject } from '../utils/browser';

(function() {
  var ItemModel, ItemView, ItemList, ConditionHeadingView, ComponentView;

  ItemModel = Backbone.Model.extend();

  // Each row in the table
  ItemView = Backbone.View.extend({
    initialize: function(o) {},
    render:     function() {
      var _attr = this.model.attributes,
        obj = _attr.reward;

      if (!obj) return false;

      obj.type = obj.itemClass;

      // move the coupon code object into the root if there is one present
      if (_attr.code) {
        obj.code = _attr.code;
      }

      // Modify the object to contain the offer - should probably be in Model.parse really
      if (obj.offer && obj.offer.action) {
        obj.target = {
          strategy: obj.offer.strategy,
          object:   isAssetRef(obj.offer.action) ? assetFromRef(obj.offer.action).src : obj.offer.action,
          text:     obj.offer.heading || obj.heading,
        };
      }

      if (obj.offer && obj.offer.strategy && obj.offer.strategy == 'strategy.delivery.coupon.image') {
        obj.badgeThumb = isAssetRef(obj.offer.action)
          ? assetFromRef(obj.offer.action, NGX.context).src
          : obj.offer.action;
      } else {
        // decode asset ref urls for rendering
        if (obj.assets) {
          if (obj.assets.main) obj.badgeSrc = assetFromRef(obj.assets.main, NGX.context).src;
          if (obj.assets.thumbnail) obj.badgeThumb = assetFromRef(obj.assets.thumbnail, NGX.context).src;
          if (obj.assets.background) obj.badgeBg = assetFromRef(obj.assets.background, NGX.context).src;
        }
      }

      // Set status flags
      if (obj.userInfo.isEligible) {
        obj.isEligible = true;
      }

      if (_attr.redemptionStatus.id === 'status.redemption.claimed') {
        obj.isEntitled = true;
      }

      //var html = this.template( obj );
      var html = ReactDOMServer.renderToStaticMarkup(<RewardInline item={obj} />);

      this.setElement($(html.trim()));
      return this;
    },
  });

  ItemList = Backbone.Collection.extend({
    // url parameters are taken from NGX.context and handled by the fetch
    url:   '/display/api/entitlement/campaign',
    model: ItemModel,
    // we override the parse method because our model definition objects is nested in response.content
    parse: function(response) {
      return response.content;
    },
  });

  // Conditional Heading.
  ConditionHeadingView = Backbone.View.extend({
    initialize: function(rewards) {
      this.hasNewlyGrantedReward = false;
      for (const rewardKey in rewards) {
        const reward = rewards[rewardKey];
        if (!reward.existing) {
          this.hasNewlyGrantedReward = true;
          break;
        }
      }

      this.moduleItem = NGX.App.config.coupon.module;
      this.moduleItem.content = {};
      this.conditionalHeaderConfig = this.hasNewlyGrantedReward ? this.moduleItem.reward : this.moduleItem.noReward;
    },
    render: function() {
      this.moduleItem.content = Object.assign(this.moduleItem.content, this.conditionalHeaderConfig);
      var headerItem = this.moduleItem;

      var html = ReactDOMServer.renderToStaticMarkup(
        <Header item={headerItem} assetUrl={NGX.context.assetUrl} assetUgcUrl={NGX.context.assetUgcUrl} />
      );

      this.setElement($(html.trim()));
      return this;
    },
  });

  ComponentView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(
        this,
        'createCollection',
        'handleResponse',
        'storeJson',
        'addAll',
        'addItem',
        'reload',
        'renderConditionalHeader'
      );
      // TODO: the xRewardsList and xRewardRow prefixes should be set in the component model on app:ready so this is more agnostic
      this.$list = $('.xContainerInner', '#xRewardsList_' + this.el.id);
      this.$conditionalHeading = $('.xConditionalHeadingWrapper', '#' + this.el.id);
      var boundFunction = function() {
        this.createCollection('items');
      }.bind(this);

      if ('undefined' === typeof FB || NGX.App.state.currentUser.accessToken) {
        boundFunction();
      } else {
        NGX.App.Events.once('fb:ready', boundFunction);
      }
    },
    // create a named collection within this view
    createCollection: function(name, cpayload) {
      var cpayload = cpayload || queryStringObject('cpayload');

      var list = (this[name] = new ItemList({
          el: this.$list,
        })),
        params = {
          apikey:     NGX.context.apikey,
          guid:       NGX.context.guid,
          campaignId: NGX.App.config.id,
          nocache:    Math.random(),
        };

      // WYN-1247 restrict to current/all rewards based on module config.
      if (NGX.App.config.coupon && NGX.App.config.coupon.rewardListStrategy == 'strategy.rewardlist.current') {
        params.current = true;
      }

      if (typeof cpayload !== 'undefined') {
        params.cpayload = decodeURIComponent(cpayload);
      }

      if (NGX.App.state.currentUser.fbid) params.fbid = NGX.App.state.currentUser.fbid;

      // if we're in preview mode pass the parameter
      if (NGX.context.isPreview === true) {
        params.preview = true;
      }
      this.listenTo(list, 'reset', this.addAll);
      this.listenTo(list, 'add', this.addItem);
      list.fetch({
        success: this.handleResponse,
        data:    params,
      });
    },

    reload: function() {
      this.$list.html('');
      var rewards = NGX.App.state.entry.entitlements;
      if (rewards) {
        for (let i = 0, n = rewards.length; i < n; i++) {
          const mdl = new ItemModel(rewards[i]);
          this.addItem(mdl);
        }
      }
    },

    handleResponse: function(collection, response) {
      this.storeJson(collection, response);
      this.renderConditionalHeader(response.content);
      NGX.App.Events.trigger('promo:ready');
    },

    // storeJson is used for list item sharing
    storeJson: function(collection, response) {
      this.model.set('response', response.content);
    },
    // build & render views for a whole collection
    addAll: function(collection) {
      this.$list.html('');
      _.each(
        collection.models,
        function(model) {
          this.addItem(model);
        },
        this
      );
    },
    // build and render an item view from its model
    addItem: function(model) {
      var obj = {
        model: model,
      };

      this.$list.append(new ItemView(obj).render().el);
    },

    renderConditionalHeader: function(response) {
      var conditionalHeading = new ConditionHeadingView(response);
      this.$conditionalHeading.replaceWith(conditionalHeading.render().el);
    },
  });

  // Push the view into the comps array, ready for the view registration
  NGX.comps.push({ type: 'myrewards', view: ComponentView });
})();
